function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var baseUrl = {
  'staging': "https://ll-mfe.staging.kuaishou.com"
};
function request(config) {
  // 默认配置
  var defaultConfig = {
    method: 'GET',
    mode: 'cors',
    credentials: 'include',
    env: 'staging',
    data: null
  };

  // 合并配置项
  var mergedConfig = Object.assign(defaultConfig, config);
  mergedConfig.method = mergedConfig.method.toUpperCase();
  // 构造查询字符串，将参数对象转换为键值对数组
  if (mergedConfig.method === 'GET' && mergedConfig.data) {
    var params = new URLSearchParams();
    Object.entries(mergedConfig.data).forEach(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        key = _ref2[0],
        value = _ref2[1];
      params.append(key, value);
    });
    mergedConfig.url += "?".concat(params.toString());
    delete mergedConfig.data;
  }

  // 将参数对象转换为字符串
  if (mergedConfig.method === 'POST' && mergedConfig.data) {
    mergedConfig.body = JSON.stringify(mergedConfig.data);
    delete mergedConfig.data;
  }

  // const curUrl = `${baseUrl[mergedConfig.env]}${mergedConfig.url}`;
  var curUrl = "".concat(mergedConfig.url);
  mergedConfig.headers = _objectSpread({
    'Content-Type': 'application/json'
  }, mergedConfig.headers);

  // 发送请求
  return fetch(curUrl, mergedConfig).then(function (response) {
    // 如果响应状态码在 200 到 299 之间，表示请求成功。401无权限，可认定为请求成功
    if (response.ok || response.status === 401) {
      // 将响应体解析为 JSON 对象
      return response.json();
    } else {
      // 抛出一个错误，提示请求失败
      throw new Error("Request failed with status ".concat(response.status));
    }
  }).catch(function (error) {
    // 处理请求失败的情况
    console.error(error);
    throw error;
  });
}
export default request;